import { render, staticRenderFns } from "./Vital.vue?vue&type=template&id=2eb6c633&scoped=true&"
import script from "./Vital.vue?vue&type=script&lang=js&"
export * from "./Vital.vue?vue&type=script&lang=js&"
import style0 from "./Vital.vue?vue&type=style&index=0&id=2eb6c633&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6c633",
  null
  
)

export default component.exports